import React from 'react';
import './TechStack.css';

function TechStack() {
  const technologies = [
    { name: 'Live Classes', icon: '🎥', color: '#1d4ed8' },
    { name: 'Recorded Lessons', icon: '▶️', color: '#2563eb' },
    { name: 'Expert Mentors', icon: '🧑‍🏫', color: '#7c3aed' },
    { name: 'Practice Modules', icon: '🧠', color: '#9333ea' },
    { name: 'Student Community', icon: '👥', color: '#0ea5e9' },
    { name: 'Assessments', icon: '✅', color: '#16a34a' },
    { name: 'Fast Support', icon: '💬', color: '#d97706' },
    { name: 'Flexible Access', icon: '🕒', color: '#dc2626' },
    { name: 'Certificate Ready', icon: '🏅', color: '#ca8a04' }
  ];

  return (
    <section className="tech-stack">
      <div className="container">
        <h2 className="section-title">
          Everything Learners Need For A <span className="highlight">Better</span><br />
          Digital Education Experience
        </h2>
        
        <div className="tech-grid">
          {technologies.map((tech, index) => (
            <div key={index} className="tech-card">
              <div className="tech-icon" style={{ color: tech.color }}>
                {tech.icon}
              </div>
              <h3 className="tech-name">{tech.name}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TechStack;
